/**
 * This file explicitly exposes environment variables to the browser.
 * In Gatsby, only variables prefixed with GATSBY_ are available in browser code.
 */

// Expose Listmonk configuration
const envConfig = {
  LISTMONK_URL: process.env.GATSBY_LISTMONK_URL,
  LISTMONK_USERNAME: process.env.GATSBY_LISTMONK_USERNAME,
  LISTMONK_PASSWORD: process.env.GATSBY_LISTMONK_PASSWORD,
  LISTMONK_WELCOME_LIST_ID: process.env.GATSBY_LISTMONK_WELCOME_LIST_ID,
  LISTMONK_WELCOME_TEMPLATE_ID: process.env.GATSBY_LISTMONK_WELCOME_TEMPLATE_ID,
  SYNC_API_KEY: process.env.GATSBY_SYNC_API_KEY,  // Keep consistent with other variables
};

// Print to console during build to verify variables are available
if (typeof window === 'undefined') {
  console.log('Environment Config (Build Time):', {
    LISTMONK_URL: envConfig.LISTMONK_URL ? 'Set' : 'Not Set',
    LISTMONK_USERNAME: envConfig.LISTMONK_USERNAME ? 'Set' : 'Not Set',
    LISTMONK_PASSWORD: envConfig.LISTMONK_PASSWORD ? 'Set' : 'Not Set',
    LISTMONK_WELCOME_LIST_ID: envConfig.LISTMONK_WELCOME_LIST_ID ? 'Set' : 'Not Set',
    LISTMONK_WELCOME_TEMPLATE_ID: envConfig.LISTMONK_WELCOME_TEMPLATE_ID ? 'Set' : 'Not Set',
    SYNC_API_KEY: envConfig.SYNC_API_KEY ? 'Set' : 'Not Set',
  });
}

export default envConfig;